import React from "react";
import { Link } from "react-router-dom";
import StarRating from "./StarRating";
import SmartImg from "./SmartImg";
import { getProductImage } from "../lib/categoryImages";
import {
  CATEGORY_ATTR_HIGHLIGHTS,
  ATTR_LABELS,
  formatAttrValue,
  formatMoney,
} from "../lib/categories";

export default function ProductCard({ product }) {
  const highlightKeys = (CATEGORY_ATTR_HIGHLIGHTS[product.category] || []).slice(0, 3);
  const attrs = product.attributes || {};

  return (
    <Link
      to={`/product/${product.id}`}
      className="group relative flex flex-col border border-neutral-200 bg-white rounded-xl overflow-hidden hover-lift"
      data-testid={`product-card-${product.id}`}
    >
      <SmartImg
        src={getProductImage(product)}
        alt={product.title}
        className="aspect-[4/3]"
        imgClassName="transition-transform duration-500 group-hover:scale-[1.04]"
      />
      <span className="absolute top-3 left-3 inline-flex items-center rounded-full bg-white/90 backdrop-blur-sm border border-neutral-200 px-2.5 py-1 text-[11px] font-medium uppercase tracking-wider text-neutral-700">
        {product.categoryLabel}
      </span>
      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2">
          <StarRating value={product.rating} count={product.reviewCount} showValue />
        </div>
        <h3
          className="font-display font-semibold text-neutral-900 text-base leading-snug line-clamp-2"
          data-testid={`product-card-title-${product.id}`}
        >
          {product.title}
        </h3>
        <p className="mt-1.5 text-xs text-neutral-500 leading-relaxed line-clamp-2">
          {product.description}
        </p>

        {highlightKeys.length > 0 && (
          <ul className="mt-3 flex flex-wrap gap-1.5">
            {highlightKeys.map((k) =>
              attrs[k] !== undefined ? (
                <li
                  key={k}
                  className="text-[11px] px-2 py-0.5 rounded-full bg-neutral-100 text-neutral-700 border border-neutral-200"
                >
                  <span className="text-neutral-500">{ATTR_LABELS[k] || k}: </span>
                  <span className="font-medium">{formatAttrValue(k, attrs[k])}</span>
                </li>
              ) : null
            )}
          </ul>
        )}

        <div className="mt-auto pt-4 flex items-baseline justify-between">
          <span
            className="font-display font-bold text-lg text-neutral-900"
            data-testid={`product-card-price-${product.id}`}
          >
            {formatMoney(product.price)}
          </span>
          <span className="text-xs text-neutral-500 group-hover:text-neutral-900 transition-colors">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
}
